import script from "./adjustReceipt.vue?vue&type=script&setup=true&lang=ts"
export * from "./adjustReceipt.vue?vue&type=script&setup=true&lang=ts"

import "./adjustReceipt.vue?vue&type=style&index=0&id=eb3f75c6&lang=scss&scoped=true"

import exportComponent from "D:\\code\\idea2023\\dmMes\\h5_standard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eb3f75c6"]])

export default __exports__